import component from "./TicketsCard";

export default component;
